import { render } from "./JoinByCode.vue?vue&type=template&id=36853746&scoped=true"
import script from "./JoinByCode.vue?vue&type=script&lang=js"
export * from "./JoinByCode.vue?vue&type=script&lang=js"

import "./JoinByCode.vue?vue&type=style&index=0&id=36853746&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36853746"]])

export default __exports__